export const Constants = {
    emailRegex: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    phoneNumberRegex: /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/,
    resetPasswordEmailAddress: "support@performhealth.it",
    defaultWeeklyBookingsLimit: 3,
    // Hour that splits in two macro time slots the business day.
    startHourOfAfternoonSlots: 13,
    weeksInMonth: 4,
    maxBookingsPerSlot: 6
};